// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Main_sidebar__1yS3F","filter":"Main_filter__2mEq7","label":"Main_label__3MxP8","form":"Main_form__1A_t9","wrap":"Main_wrap__3jXYI"};